import type { SummaryResource } from "@octopusdeploy/octopus-server-client";
import { CommunicationStyleValues } from "@octopusdeploy/octopus-server-client";
import type { LinkHref } from "@octopusdeploy/portal-routes";
import { useEffect, useState } from "react";
import { StepPackageDeploymentTargetRow } from "~/areas/infrastructure/components/InfrastructureDashboard/MachinesCard/StepPackageDeploymentTargetRow";
import type { EndpointRegistration, StepPackageDeploymentTargetRegistration } from "~/areas/infrastructure/components/MachineSettings/Endpoints/endpointRegistry";
import endpointRegistry from "~/areas/infrastructure/components/MachineSettings/Endpoints/endpointRegistry";
import type { DoBusyTask } from "~/components/DataBaseComponent";
import styles from "../style.module.less";
import { MachinesContentRow } from "./MachinesContentRow";
interface MachinesContentProps {
    summaryResource: SummaryResource;
    link: (obj: MachinesContentFilter) => LinkHref;
    doBusyTask: DoBusyTask;
}
export interface MachinesContentFilter {
    deploymentTargetTypes: string[];
}
export const MachinesContent = ({ summaryResource, link, doBusyTask }: MachinesContentProps) => {
    const [registrations, setRegistrations] = useState<EndpointRegistration[]>([]);
    useEffect(() => {
        (async () => {
            await doBusyTask(async () => {
                const loadedRegistrations = await endpointRegistry.getAllRegistrations();
                setRegistrations(loadedRegistrations);
            });
        })();
    }, [doBusyTask]);
    return (<>
            {registrations?.length > 0 && (<div className={styles.cardContentContainerRows}>
                    {Object.keys(summaryResource.DeploymentTargetSummaries).map((keyString) => {
                const registration = registrations.find((r) => r.key === keyString);
                if (registration?.communicationStyle !== CommunicationStyleValues.StepPackage)
                    return <MachinesContentRow key={keyString} deploymentTargetType={keyString} link={(commStyle) => link({ deploymentTargetTypes: [commStyle] })} summaries={summaryResource.DeploymentTargetSummaries}/>;
                else {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const stepPackageEndpointRegistration = registration as StepPackageDeploymentTargetRegistration;
                    return <StepPackageDeploymentTargetRow key={keyString} deploymentTargetRegistration={stepPackageEndpointRegistration} link={link} summaries={summaryResource.DeploymentTargetSummaries}/>;
                }
            })}
                </div>)}
        </>);
};
